






















import {Component, Vue} from 'vue-property-decorator';
import EditDialog from './CompanyEditDialog.vue';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';
@Component({
    components: {CFlexGrid},
})
export default class Company extends Vue {
    private editDialog = EditDialog;

    async onFill(item: any) {
        if (item.IsLocked) return;
        const {data} = await this.$http.get(`${this.$api.administration.company}/Fill`, {
            params: {
                id: item.Id,
            },
        });
        (this.$refs as any).flexGrid.updateData(data);
    }
}
